import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SEO from '../../../component/common/SEO';
import { pageSEO } from '../../../config/seoConfig';
import { IoMdCheckmark } from 'react-icons/io';
import { RxCross2 } from 'react-icons/rx';
import WebButton from '../../../component/library/webButton';
import GmailIcon from '../../../assets/images/icons/gmail.png';
import ContactIcon from '../../../assets/images/icons/contact.png';
import { ToastTypes, useMessage } from '../../../base/context/MessageProvider';
import { SubscriptionApiService } from '../../../service/website/subscriptionApiService';
import { getAuthLocalStorage } from '../../../storage/localStorage';
import './style.css';

export default function Pricing() {
  const message = useMessage();

  const [subscriptions, setSubscriptions] = useState([]);

  const handleSubscriptions = () => {
    SubscriptionApiService.getSubscription()
      .then(res => {
        if (res.status.code === 200) {
          setSubscriptions(res.data);
        } else {
          message.showToast(res.error.message, ToastTypes.ERROR);
        }
      })
      .catch(err => {
        if (err.status.code === 500) {
          message.showToast('Invalid credentials', ToastTypes.ERROR);
        } else {
          message.showToast(err?.message || 'Server error. Try again later', ToastTypes.ERROR);
        }
      });
  };

  useEffect(() => {
    handleSubscriptions();
  }, []);

  return (
    <div className="pricing_bg">
      <SEO {...pageSEO.pricing} />
      <div className="pricing_info">
        <h1>The Right Plan for Your Business</h1>
        <h1>No Charges for SP-API integration for Amazon sellers.</h1>
        <p>We have several powerful plans to showcase your business and get discovered as a creative entrepreneurs. Everything you need.</p>
        {/* <p>Importerr is free for Amazon sellers. No charges for SP-API integration.</p> */}
      </div>

      <div className="plans_row">
        {subscriptions.map(subscription => {
          return <PlansCard key={subscription._id || subscription.id} subscription={subscription} />;
        })}
      </div>
    </div>
  );
}

const PlansCard = ({ subscription }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const message = useMessage();

  const handleChoosePlan = () => {
    const auth = getAuthLocalStorage();
    const isLoggedIn = auth.isLoggedIn && auth.loginHeader;

    if (!isLoggedIn) {
      message.showToast('Please login to choose a plan', ToastTypes.WARNING);
      navigate('/login', { state: { from: location } });
      return;
    }

    // Check if user is a seller/admin
    const isSeller = auth.userType === 'seller' || auth.userType === 'admin' || auth.userType === 'sub-admin';
    
    if (!isSeller) {
      message.showToast('This plan is available for sellers only. Please login as a seller.', ToastTypes.WARNING);
      navigate('/login', { state: { from: location } });
      return;
    }

    // TODO: Implement subscription purchase flow
    // For now, show a message and navigate to product subscription page
    message.showToast(`Selected ${subscription?.name} plan. Redirecting...`, ToastTypes.SUCCESS);
    
    // Navigate to product subscription page or checkout
    setTimeout(() => {
      navigate('/seller/wallet');
    }, 1000);
  };

  return (
    <div className="plans_card_box">
      <h1>{subscription?.name}</h1>

      <h3>{subscription.orderDispatch} Order Dispatch</h3>

      <p>
        <IoMdCheckmark />
        Free SP-API integration for Amazon sellers.
      </p>

      {subscription.features.map((feature, index) => {
        return (
          <p key={index}>
            {feature.enabled ? <IoMdCheckmark /> : <RxCross2 />}
            {feature.name}
          </p>
        );
      })}

      <h2>
        {subscription?.timePeriod}
        <span> / &#8377; {subscription?.price} </span>
      </h2>

      <div className="plans_card_btn_row">
        <WebButton className="profile_submit_btn" text="Choose" onClick={handleChoosePlan} type="button" />
      </div>
    </div>
  );
};

export const FooterQuery = () => {
  return (
    <div className="query_contact_section">
      <div className="query_contact_column">
        <h1>FOR QUERIES CONTACT US ON</h1>
      </div>
      <div className="query_contact_column">
        <img src={GmailIcon} />
        <p>hr@boundlesstrends.com</p>
      </div>
      <div className="query_contact_column">
        <img src={ContactIcon} />
        <p>+91 9876543210</p>
      </div>
    </div>
  );
};
